import React, { useEffect, useState } from "react";
import { Col, Row, Container, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import storage from "helpers/storage";
import DashbordIconCalendar from "assets/images/dashbord-icon-calendar.svg";
import DashbordIconPending from "assets/images/dashbord-icon-pending.svg";
import DashbordIconCertificates from "assets/images/dashbord-icon-certificates.svg";
import DashbordIconDollarSign from "assets/images/dashbord-icon-dollar-sign.svg";
import { dashboardTilesCounts } from "services/dashboard";
import { nameBasedProtectedRoutes } from "router/protected";

export const TopTiles = (props) => {
  const [upcomingInspection, setUpcomingInspection] = useState(0);
  const [outstandingDeficiencies, setOutstandingDeficiencies] = useState(0);
  const [activeCertificates, setActiveCertificates] = useState(0);
  const [outstandingInvoices, setOutstandingInvoices] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    dashboardTilesCounts(props.userId, { search: props.search }).then((response) => {
      setUpcomingInspection(response?.upcomingInspection);
      setOutstandingDeficiencies(response?.outstandingDeficiencies);
      setActiveCertificates(response?.activeCertificates);
      setOutstandingInvoices(response?.outstandingInvoices);
    });
  }, [props.search]);

  return (
    <>
      <Row className="mb-4">
        <Col md={6} lg={6} xl={3}>
          <a href="#upcomingInspection" className="text-decoration-none">
            <Card className="dashboard-box border-0 dashboard-bg-blue">
              <div className="dashboard-img-icon">
                <Card.Img variant="top" src={DashbordIconCalendar} />
              </div>
              <Card.Body>
                <Card.Text className="text-white fs-45 fw-bold lh-45 mb-0">
                  {upcomingInspection ? upcomingInspection : 0}
                </Card.Text>
                <Card.Title className="text-white fs-20 fw-bold mb-0">
                  Upcoming Inspections
                </Card.Title>
                <Card.Text className="text-white fs-15">
                  Scheduled Inspections
                </Card.Text>
              </Card.Body>
            </Card>
          </a>
        </Col>
        <Col md={6} lg={6} xl={3}>
          <a href="#outstandingDeficiency" className="text-decoration-none">
            <Card className="dashboard-box border-0 dashboard-bg-red">
              <div className="dashboard-img-icon">
                <Card.Img variant="top" src={DashbordIconPending} />
              </div>
              <Card.Body>
                <Card.Text className="text-white fs-45 fw-bold lh-45  mb-0">
                  {outstandingDeficiencies ? outstandingDeficiencies : 0}
                </Card.Text>
                <Card.Title className="text-white fs-20 fw-bold mb-0">
                  Outstanding Deficiencies
                </Card.Title>
                <Card.Text className="text-white fs-15">
                  Correct Issues & Sign
                </Card.Text>
              </Card.Body>
            </Card>
          </a>
        </Col>
        <Col md={6} lg={6} xl={3}>
          <a
            href="javascript:void(0)"
            onClick={() =>
              navigate(nameBasedProtectedRoutes.inspections.path, {
                state: {
                  activeCertificate: true,
                },
              })
            }
            className="text-decoration-none"
          >
            <Card className="dashboard-box border-0 dashboard-bg-green">
              <div className="dashboard-img-icon">
                <Card.Img variant="top" src={DashbordIconCertificates} />
              </div>
              <Card.Body>
                <Card.Text className="text-white fs-45 fw-bold lh-45 mb-0">
                  {activeCertificates ? activeCertificates : 0}
                </Card.Text>
                <Card.Title className="text-white fs-20 fw-bold mb-0">
                  Active Certificates
                </Card.Title>
                <Card.Text className="text-white fs-15">
                  Certified Devices
                </Card.Text>
              </Card.Body>
            </Card>
          </a>
        </Col>
        <Col md={6} lg={6} xl={3}>
          <a
            href="javascript:void(0)"
            onClick={() =>
              navigate(nameBasedProtectedRoutes.billsAndPayments.path, {
                state: {
                  dueInvoice: true,
                },
              })
            }
            className="text-decoration-none"
          >
            <Card className="dashboard-box border-0 dashboard-bg-yellow">
              <div className="dashboard-img-icon">
                <Card.Img variant="top" src={DashbordIconDollarSign} />
              </div>
              <Card.Body>
                <Card.Text className="text-white fs-45 fw-bold lh-45 mb-0">
                  {outstandingInvoices ? outstandingInvoices : 0}
                </Card.Text>
                <Card.Title className="text-white fs-20 fw-bold mb-0">
                  Outstanding Invoices
                </Card.Title>
                <Card.Text className="text-white fs-15">
                  Outstanding Invoices
                </Card.Text>
              </Card.Body>
            </Card>
          </a>
        </Col>
      </Row>
    </>
  );
};
